<h1 mat-dialog-title>Request access to this {{ learnspace.mode | spaceLabel }}</h1>
<ng-container *ngIf="!this.message; else messageBlock">
  <div mat-dialog-content *ngIf="learnspace" class="dialog-content">
    <p>Your are about to request access to this {{ learnspace.mode | spaceLabel }} as a {{ learnspace.mode | participantLabel }}. If accepted, by {{ getOwnerName() }}, you’ll be able to edit all {{ learnspace.mode | spaceLabel }} content<br>
      <br>This {{ learnspace.mode | spaceLabel }} is owned by <b>{{ getOwnerName() }}</b>
    </p>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button (click)="this._dialogRef.close();">Cancel</button>
    <button mat-raised-button (click)="requestLearnspaceAccess();" cdkFocusInitial color="primary">Request</button>
  </div>
</ng-container>
<ng-template #messageBlock>
    <div mat-dialog-content class="dialog-content">
      {{ message }}
    </div>
    <div mat-dialog-actions class="dialog-actions">
      <button mat-raised-button (click)="this._dialogRef.close();">OK</button>
    </div>
</ng-template>